
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import { iconNamesColor, TEMPLATE_COLOR_THEME_GUIDE } from '@/utils/constant'
import HomeMixin from '@/views/mixins/HomeMixin'
import { mapGetters, mapActions } from 'vuex'
import GuideService from '@/components/GuideService'

export default {
mixins: [HomeMixin],
components: {
Flexbox,
FlexboxItem,
Toast,
Loading,
GuideService
},
data(){
return {
iconNames: iconNamesColor,
isShowGuideService: false
}
},
computed: {
...mapGetters([
'iconColor',
'bannerColorStart',
'bannerColorEnd'
])
},
methods: {
...mapActions([
'getTheme'
]),
guide() {
let path = this.$route.path;
let orgUid = this.$route.params.orgUid;
this.$router.push({path: `/${this.template}/symptom/${orgUid}`, query: {source: path}});
}
},
mounted: function () {
this.initPage();
this.getTheme(this.orgUid).then(({theme}) => {
if (theme === TEMPLATE_COLOR_THEME_GUIDE) {
this.isShowGuideService = true
}
})
}
}



// WEBPACK FOOTER //
// ./src/views/liyanke/Consult.vue